import DefaultValidation from "@/services/validations/DefaultValidation";
import Message from '@/models/Message';

export default class ConfigurarRecibosValidation extends DefaultValidation{

  constructor(msgs) {
    super(msgs);
  }

  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (model.valor==0 || model.idtipoveiculo==null) {
      refs.valorInput.focusedOut = true;
      refs.tipoVeiculoSelect.focusedOut = true;
      validated = false;
      this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
    }
    
    return validated;
  }

}